var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from 'app/core/api/api.js';
const initialState = {
    data: [],
    loading: false,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
export const fetchOfficeUsers = createAsyncThunk('users/fetchOfficeUsers', (_a, _b) => __awaiter(void 0, [_a, _b], void 0, function* ({ officeId, pageSize, currentPage }, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.assets.children({ id: officeId }, {
            page_size: pageSize,
            page: currentPage,
        });
        return fulfillWithValue(res.results);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const createUserFromOffice = createAsyncThunk('users/create', (user_1, _a) => __awaiter(void 0, [user_1, _a], void 0, function* (user, { fulfillWithValue, rejectWithValue }) {
    try {
        const res = yield api.users.create(user);
        return fulfillWithValue(res);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
export const deleteUserFromOffice = createAsyncThunk('users/delete', (userId_1, _a) => __awaiter(void 0, [userId_1, _a], void 0, function* (userId, { fulfillWithValue, rejectWithValue }) {
    try {
        yield api.users.delete(userId);
        return fulfillWithValue(userId);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const { reducer } = createSlice({
    name: 'users',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // FETCH USERS ASSETS
        builder.addCase(fetchOfficeUsers.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchOfficeUsers.fulfilled, (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
            state.loading = false;
        });
        builder.addCase(fetchOfficeUsers.rejected, (state, { payload }) => {
            state.loading = false;
        });
        // CREATE USER
        builder.addCase(createUserFromOffice.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createUserFromOffice.fulfilled, (state, { payload }) => {
            const t = [...state.data, payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
            state.loading = false;
        });
        builder.addCase(createUserFromOffice.rejected, (state, { payload }) => {
            state.loading = false;
        });
        // DELETE USER
        builder.addCase(deleteUserFromOffice.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteUserFromOffice.fulfilled, (state, { payload }) => {
            state.data = state.data.filter((user) => user.id !== payload);
            state.loading = false;
        });
        builder.addCase(deleteUserFromOffice.rejected, (state, { payload }) => {
            state.loading = false;
        });
    },
});
export default reducer;
